<template>
	<v-date-picker
		:value="value"
		color="indigo"
		:min-date="minDate"
		:max-date="maxDate"
		@input="changeValue"
	>
		<template #default="{ inputValue, togglePopover }">
			<label
				class="form-label"
				:for="id"
				>{{ label }}</label
			>
			<div class="datepicker">
				<i
					class="far fa-calendar-alt"
					@click="togglePopover({ placement: 'auto-start' })"
				/>
				<div class="ui input">
					<input
						:id="id"
						class="form-input"
						type="text"
						:placeholder="placeholder != null ? placeholder : label"
						:readonly="true"
						:value="inputValue"
						@click="togglePopover({ placement: 'auto-start' })"
					/>
				</div>
			</div>
		</template>
	</v-date-picker>
</template>

<script>
export default {
	props: {
		/**
		 * Id do componente
		 */
		id: String,
		/**
		 * Label do componente
		 */
		label: String,
		/**
		 * Placeholder do componente
		 */
		placeholder: String,
		/**
		 * Valor que sera feito o bind
		 */
		value: { type: String, default: () => new Date().toISOString() },
		/**
		 * Valor minimo para a data
		 */
		minDate: String,
		/**
		 * Valor maximo para a data
		 */
		maxDate: String,
	},
	methods: {
		changeValue(date) {
			const dataValida = !isNaN(new Date(date))
			if (dataValida && date) this.$emit('input', date.toISOString())
			else this.$emit('input', '')
		},
	},
}
</script>

<style scoped>
.ui.input {
	width: 100%;
	font-size: 0.75rem;
}

.ui.input > input {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
	cursor: pointer;
}

.datepicker {
	display: flex;
}

.datepicker i {
	font-size: 1rem;
	padding: 0.5rem;
	align-self: stretch;
	border-top: 1px solid rgb(var(--color-gray));
	border-bottom: 1px solid rgb(var(--color-gray));
	border-left: 1px solid rgb(var(--color-gray));
	border-top-left-radius: 0.28rem;
	border-bottom-left-radius: 0.28rem;
	background-color: rgb(var(--color-primary));
	color: white;
	cursor: pointer;
}
</style>
